function handleGetResponseData(response: any) {
  const details = response?.data?.details

  if (!details) {
    return response
  }

  const { message, type, data } = details

  return {
    ...response,
    data: {
      ...(message && { message }),
      ...(data || {}),
      ...(type && { type }),
      ...details
    }
  }
}

export { handleGetResponseData }
